import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
// import ImageUploader from "../../components/ImageUploader";
// import { Images } from "../../components/Interfaces/ImageData";

export default function RegisterPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  //   const [profileImage, setProfileImage] = useState<Images>();
  const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate(); // Hook for navigation

  const handleRegisterSubmit = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault(); // Prevent the default form submission behavior

    try {
      const payload = { name, email, password, mobile };
      const response = await axios.post("/api/account/create", payload);
      if (response.status === 200) {
        // Registration successful, set redirect to true
        setRedirect(true);
      } else {
        // Handle unexpected response status
        console.error("Unexpected response status:", response.status);
      }
    } catch (error) {
      console.error("Error submitting register form:", error);
      toast.error("An error occurred while registering. Please try again."); // Show error message
    }
  };

  useEffect(() => {
    if (redirect) {
      navigate("/login");
    }
  }, [redirect]);

  return (
    <div className="mt-4 grow flex items-center justify-around">
      <div className="mb-64">
        <h1 className="text-4xl text-center p-4">Register</h1>
        <form
          className="flex flex-col max-w-2xl mx-auto gap-4"
          onSubmit={handleRegisterSubmit}
        >
          <input
            type="text"
            placeholder="name"
            id="name"
            name="name"
            value={name}
            onChange={(ev) => setName(ev.target.value)}
            className="input-field"
          />
          <div className="flex flex-col gap-2">
            <input
              type="email"
              placeholder="example@email.com"
              id="email"
              name="email"
              value={email}
              onChange={(ev) => setEmail(ev.target.value)}
              className="input-field"
            />
          </div>
          <div className="flex flex-col gap-2">
            <input
              type="password"
              placeholder="password"
              id="password"
              name="password"
              value={password}
              onChange={(ev) => setPassword(ev.target.value)}
              className="input-field"
            />
          </div>
          <div className="flex flex-col gap-2">
            <input
              type="Mobile"
              placeholder="Mobile Number"
              id="mobile"
              name="mobile"
              value={mobile}
              onChange={(ev) => setMobile(ev.target.value)}
              className="input-field"
            />
          </div>
          {/* <ImageUploader
            existingImages={profileImage} // Pass existing images to the uploader
            onImagesChange={(newImages) => {
              setProfileImage(newImages);
            }}
            maxImages={1}
          /> */}
          <button
            type="submit"
            className="bg-blue-500 text-white rounded-2xl p-2"
          >
            Register
          </button>
          <div className="text-center py-2 text-gray-500">
            Already a member?
            <Link className="underline text-black" to={"/login"}>
              Login now
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
